<template>
	<div class="app-wrapper" :class="classObj">
		<div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div>
		<sidebar class="sidebar-container"></sidebar>
		<div class="main-container">
<!--			<div class="fixed-header">-->
<!--				<navbar></navbar>-->
<!--			</div>-->
            <div :class="{'fixed-header':fixedHeader}">
                <navbar />
                <tags-view v-if="needTagsView" />
            </div>
			<app-main></app-main>
			<myfoot></myfoot>
		</div>
	</div>
</template>

<script>
	import { Navbar, Sidebar, AppMain,TagsView } from './components'
	import ResizeMixin from './mixin/ResizeHandler'
	import myfoot from '@/components/Footer/index'

	export default {
	  name: 'layout',
	  components: {
	    Navbar,
	    Sidebar,
	    AppMain,
	    myfoot,
          TagsView
	  },
	  mixins: [ResizeMixin],
	  computed: {
          needTagsView(){
              return true
          },
          fixedHeader(){
              return true;
          },
	    sidebar() {
	      return this.$store.state.app.sidebar
	    },
	    device() {
	      return this.$store.state.app.device
	    },
	    classObj() {
	      return {
	        hideSidebar: !this.sidebar.opened,
	        openSidebar: this.sidebar.opened,
	        withoutAnimation: this.sidebar.withoutAnimation,
	        mobile: this.device === 'mobile'
	      }
	    }
	  },
	  methods: {
	    handleClickOutside() {
	      this.$store.dispatch('CloseSideBar', {
	        withoutAnimation: false
	      })
	    }
	  }
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@import "src/styles/mixin.scss";
	@import 'src/styles/variables.scss';
	.app-wrapper {
		@include clearfix;
		position: relative;
		height: 100%;
		width: 100%;
		&.mobile.openSidebar {
			position: fixed;
			top: 0;
		}
	}

	.drawer-bg {
		background: #000;
		opacity: 0.3;
		width: 100%;
		top: 0;
		height: 100%;
		position: absolute;
		z-index: 999;
	}

	 .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width:calc( 100%  - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 36px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue